// extracted by css-extract-rspack-plugin
export default {"linkImage":"_981b6d84"};